import { render, staticRenderFns } from "./NewsSubmenu.vue?vue&type=template&id=3808df72"
import script from "./NewsSubmenu.vue?vue&type=script&lang=js"
export * from "./NewsSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports